export default __webpack_public_path__ + "static/course-logo-cur-e54ce4a2ae7c3ff748a37c78745af148.jpg";